import { owaComputedFn } from "owa-computed-fn";
import { createLazyRibbonTabDefinition } from "owa-command-ribbon";
import { type HelpRibbonTabId } from "owa-ribbon-ids/lib/helpControlId";
import { help_tab as Strings_help_tab } from "owa-locstrings/lib/strings/ribbon_app_buttons_and_tabs.locstring.json";
import loc from "owa-localize";
import type { RibbonId } from "owa-ribbon-ids";
import { lazyGetSLRHelpTabGroups, lazyGetMLRHelpTabGroups } from "./lazyFunctions";
import type { RibbonTabDefinitionBase } from "owa-acui";

export const getHelpTab: (currentTab: RibbonId) => RibbonTabDefinitionBase = owaComputedFn((currentTab: RibbonId): RibbonTabDefinitionBase => {
    return createLazyRibbonTabDefinition(currentTab, 11000, loc(Strings_help_tab), lazyGetSLRHelpTabGroups, lazyGetMLRHelpTabGroups);
});
